import { ErrorMessage } from '@hookform/error-message';
import classNames from 'classnames';
import { Error } from 'components/InputsMex/containers/components';
import React, { useEffect, useState } from 'react';
import { Button, ButtonGroup } from 'react-bootstrap';
import { Button as ButtonPrime } from 'primereact/button';
import { Controller, useFormContext } from 'react-hook-form';
import styled from 'styled-components';
import { match } from 'x-match-expression';
import './styles.scss';

export const OpcionesContratante = ({ name = '', rules, opciones = [] }) => {
  const { control, errors } = useFormContext();


  return (
    <React.Fragment>
      <Controller
        control={control}
        name={name}
        rules={rules}
        render={({ onChange, value }) => {
          return (
            <React.Fragment>
              <ButtonGroup className="row d-flex justify-content-center">
                {opciones?.map((opcion, index) => (
                  <Button
                    key={`opcion-${name}-${index}`}
                    className={`col-xl-5 col-12 mx-2 text-center custom-button-group ${value === opcion?.value ? 'button-active' : ''
                      }`}
                    onClick={() => onChange(opcion?.value)}
                  >
                    <img
                      src={opcion?.img}
                      alt={`icono-${name}-${index}`}
                      height="100em"
                    />
                    <h4 className="text-capitalize">{opcion?.label}</h4>
                  </Button>
                ))}
              </ButtonGroup>

              <div className="text-center mx-auto">
                <ErrorMessage
                  name={name}
                  errors={errors}
                  render={({ message }) => <Error width="95%">{message}</Error>}
                />
              </div>
            </React.Fragment>
          );
        }}
      />
    </React.Fragment>
  );
};

const CabeceraPlanes = ({ opcion, stripColor }) => (
  <div style={{ height: '250px' }}>
    <div
      className="w-100 font-mex text-mex text-center font-20px mt-4 pt-4 "
      style={{ backgroundColor: stripColor, paddingBottom: '0.5rem' }}
    >
      <h4>{opcion?.nombreOpcion}</h4>
    </div>
    <h6 className="font-source-sans-regular text-mex my-3 text-center">
      {opcion?.textCabecera || 'Prima total'}
    </h6>
    <h5 className=" font-source-sans-regular text-center font-mex text-mex font-weight-bold text-primary h3 my-4 font-24px">
      {opcion?.primaTotal}
    </h5>
    {opcion?.precioFormatoMensual && <h6 className="font-source-sans-regular text-center" style={{ color: 'rgb(0, 164, 228)' }}>desde {opcion?.precioFormatoMensual} pago mensual*</h6>}
    {opcion?.textColumnas && <div
      dangerouslySetInnerHTML={{
        __html: opcion.textColumnas,
      }}
    />}

  </div>
);

export const OpcionesPlanes = ({
  name = '',
  rules,
  setOpcionSeleccionada,
  opcionesCompletas = [],
  opciones = [],
  etiquetas = [],
  siguienteActive,
  atrasActive,
  textoLabel = 'Opciones',
  opcionSeleccionada = null,
  onClickSiguienteAtras = () => { },
  identificadorPlan: identificador = 'sumallaveAsegurada',
  ModalPlan = false,
  ModalInfo = false,
  classToShow = 'container-rcpa-planes',
  showToolTip = true,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [showModalInfo, setShowModalInfo] = useState(false);
  const { control, errors, setValue } = useFormContext();
  const [retroactividadSeleccionada, setRetroactividadSeleccionada] = useState(null);
  const stripColors = ['#C0E7F7', '#F2B773', '#B598E3', '#9ADDD8'];
  const [visiblePlan, setVisiblePlan] = useState((opciones.length > 0) ? [opcionesCompletas[0]] : []);

  const nextBackPlan = (forward = true) => {
    if (forward) {
      setVisiblePlan([opcionesCompletas[opcionesCompletas?.indexOf(visiblePlan[0]) + 1]])
    } else {
      setVisiblePlan([opcionesCompletas[opcionesCompletas?.indexOf(visiblePlan[0]) - 1]])
    }
  }
  const openPopUp = (opcion) => {
    //setRetroactividadSeleccionada(opcion?.codigoRetroactividad);
    //setOpcionSeleccionada(opcion);
    setShowModal(true);
  }
  useEffect(() => {
    setValue(name, opcionSeleccionada?.[identificador]);
    setVisiblePlan([opcionSeleccionada]);
  }, [opcionSeleccionada, setValue, name])

  useEffect(() => {
    if (opciones?.length > 0) {
      setRetroactividadSeleccionada(opciones?.filter(opt => opt !== false)?.[0]?.popUp?.find(opt => opt.seleccion === true)?.codigoRetroactividad || 0);
    }
  }, [opciones])

  useEffect(() => {
    if (opciones?.lenght > 0) {
      setVisiblePlan([opcionSeleccionada || opcionesCompletas[0]]);
    }
  }, [opcionesCompletas, opcionSeleccionada])

  return (
    <React.Fragment>
      <Controller
        control={control}
        name={name}
        rules={rules}
        render={({ onChange, value }) => {
          return (
            <React.Fragment>
              <div className="d-none d-lg-block">
                <ButtonGroup className="d-flex justify-content-center">
                  <div className={classToShow + " p-2 position-relative"}>
                    {(atrasActive) && <div onClick={() => { onClickSiguienteAtras(false) }} className={`position-absolute d-flex align-content-center button-atras${opciones.filter(opt => opt !== false).length === 1 ? '' : '-full'} d-block`}><span className="arrow mt-3">❬</span></div>}
                    {(siguienteActive) && <div onClick={() => { onClickSiguienteAtras(true) }} className="position-absolute d-flex align-content-center button-siguiente d-block"><span className="arrow mt-3">❭</span></div>}
                    <div className="d-flex flex-wrap align-content-center mt-5">
                      <div className="font-mex text-mex font-20px col text-left mt-3">
                        <b>{textoLabel}</b>
                      </div></div>
                    {opciones?.map((opcion, index) => (
                      <>{(opcion) ?
                        <div
                          key={`op-cob-hogar${index}`}
                          className={classNames('plan-pago-container cb-opHogar', {
                            'plan-activo': value === opcion?.[identificador],
                            'card-login-mex': value !== opcion?.[identificador],
                            'pb-30': typeof opcion?.textColumnas === 'string'
                          })}
                          onClick={() => { setOpcionSeleccionada(opcion); onChange(opcion?.[identificador]); openPopUp(opcion) }}
                        >
                          <CabeceraPlanes
                            opcion={opcion}
                            stripColor={stripColors[opciones.filter(opc => opc !== false).indexOf(opcion)]}

                          />
                        </div> : <div className='w-0'></div>}
                      </>
                    ))}
                    {ModalInfo && <ModalInfo setShowModal={setShowModalInfo} showModal={showModalInfo} />}
                    {ModalPlan && <ModalPlan retroactividadSeleccionada={retroactividadSeleccionada}
                      setRetroactividadSeleccionada={setRetroactividadSeleccionada}
                      stripColor={stripColors?.[opciones.filter(opc => opc !== false).indexOf(opcionSeleccionada)]}
                      setShowModal={setShowModal}
                      showModal={showModal}
                      plan={opcionSeleccionada}
                    >
                    </ModalPlan>}
                    {etiquetas.map((etiqueta, i) =>
                      <React.Fragment key={`opci2123${i}`}>
                        <div className="font-source-sans-regular font-19px text-labels-izquierdo text-left mt-2">
                          <div
                            dangerouslySetInnerHTML={{
                              __html: `${(etiqueta?.titulo === true) ? '<b>' + etiqueta?.label + '</b>' : etiqueta?.label} <div class='text-justify font-17px'>${(etiqueta?.texto) ? etiqueta.texto : ''}</div>`,
                            }}
                            onClick={() => etiqueta?.onClick && etiqueta?.onClick(setShowModalInfo)}
                          />
                        </div>
                        {opciones.map((opcion, j) => (
                          <>{(opcion) ?
                            <div
                              className={`d-flex justify-content-center px-3 ${value === opcion?.[identificador]
                                ? 'plan-activo card-border-lateral-activo '
                                : 'card-border-lateral'
                                }`}
                              style={{
                                borderTop: '0px !important',
                                borderBottom: '0px !important',
                              }}
                              onClick={() => { setOpcionSeleccionada(opcion); onChange(opcion?.[identificador]); (ModalPlan) && openPopUp(opcion) }}
                            >
                              {opcion?.[etiqueta.id] &&
                                <>
                                  <div className={`font-source-sans-regular font-19px text-lg-center text-left mt-3 
                                  ${classToShow === 'container-rcpa-planes' ?
                                      'label-max-width-planes' :
                                      'label-max-width-planes-sbs'}`}>
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: opcion[etiqueta.id],
                                      }}
                                    />
                                  </div>
                                </>
                              }
                              {(etiqueta.id === 'deducibleValor' && opcion?.deducibleTexto !== '' && showToolTip) && <ButtonPrime
                                type="button"
                                style={{ borderRadius: '25%' }}
                                className=" p-button-text p-button-plain p-0 pl-1 font-20px button-help-planes mt-3"
                                tooltip={opcion?.deducibleTexto}
                              >
                                <i
                                  className="pi pi-question-circle"
                                  style={{ fontSize: '1rem' }}
                                />
                              </ButtonPrime>}
                              {(etiqueta.id === 'codigoRetroactividad') && <div className="font-source-sans-regular font-19px text-lg-center text-left mt-3 label-max-width-planes">{opcion?.popUp?.find(re => re.seleccion === true)?.retroactividad}</div>}
                            </div> : <div></div>}
                          </>
                        ))}
                      </React.Fragment>
                    )}
                    <div></div>
                    {opciones?.map((opcion, index) => (
                      <>{(opcion) ?
                        <div
                          key={`opcines11${index}`}
                          className={`pt-3 ${value === opcion?.[identificador]
                            ? 'plan-activo card-border-lateral-activo '
                            : 'card-border-lateral'
                            }`}
                        >
                          <Button
                            variant={
                              value === opcion?.[identificador] ? 'primary' : 'outline-primary'
                            }
                            className="mx-auto text-center w-100 mt-3"
                            style={{ whiteSpace: 'break-spaces' }}
                            onClick={() => { setOpcionSeleccionada(opcion); onChange(opcion?.[identificador]); (ModalPlan) && openPopUp(opcion) }}
                          >
                            <span className="text-wrap">ELIJO ESTE PLAN</span>
                          </Button>
                        </div> : <div></div>}</>
                    ))}
                  </div>
                </ButtonGroup>
              </div >
              <div className="d-lg-none">
                <ButtonGroup className="d-flex justify-content-center">
                  <div className="container-rcpa-planes-responsive p-2 position-relative">
                    {(opcionesCompletas?.indexOf(visiblePlan[0]) > 0) && <div onClick={() => { nextBackPlan(false) }} className="position-absolute d-flex align-content-center button-atras-responsive d-block"><span className="arrow mt-3">❬</span></div>}
                    {(opcionesCompletas?.indexOf(visiblePlan[0]) !== opcionesCompletas.length - 1) && <div onClick={() => { nextBackPlan(true) }} className="position-absolute d-flex align-content-center button-siguiente-responsive d-block"><span className="arrow mt-3">❭</span></div>}
                    {visiblePlan?.map((opcion, index) => {
                      const stripColor = stripColors[(opcionesCompletas?.indexOf(visiblePlan[0]) - 4 < 0) ? opcionesCompletas?.indexOf(visiblePlan[0]) : opcionesCompletas?.indexOf(visiblePlan[0]) - 4];
                      return (
                        <div
                          className="col-md-12 col-lg-2  col-sm-12"
                          key={`opcion-${name}-${index}`}
                          onClick={() => { setOpcionSeleccionada(opcion);; onChange(opcion?.[identificador]); (ModalPlan) && openPopUp(opcion) }}
                        >
                          <div
                            className={classNames('plan-pago-container', {
                              'plan-activo': value === opcion?.[identificador],
                              'card-login-mex': value !== opcion?.[identificador],
                            })}
                          >
                            <CabeceraPlanes opcion={opcion} stripColor={stripColor} />
                            <div className="plan-pago-coberturas">
                              {etiquetas.map((etiqueta, j) => (
                                <div
                                  className="mb-2 font-source-sans-regular font-19px"
                                  key={etiqueta?.cobertura}
                                >
                                  <CoberturaXL length={etiqueta?.cobertura?.length}>
                                    <div className="row d-flex justify-content-center mx-3">
                                      <div className="col-6 text-left">
                                        <div
                                          dangerouslySetInnerHTML={{
                                            __html: (etiqueta?.titulo === true) ? '<b>' + etiqueta?.label + '</b>' : etiqueta?.label,
                                          }}
                                          onClick={() => etiqueta?.onClick && etiqueta?.onClick(setShowModalInfo)}
                                        />
                                      </div>
                                      <div className="col-6 text-left align-self-center">
                                        <div
                                          className={`d-flex justify-content-center px-3 `}
                                          style={{
                                            borderTop: '0px !important',
                                            borderBottom: '0px !important',
                                          }}
                                          onClick={() => { setOpcionSeleccionada(opcion); onChange(opcion?.[identificador]); (ModalPlan) && openPopUp(opcion) }}
                                        >
                                          <div className="font-source-sans-regular font-19px text-lg-center text-left mt-3"><div
                                            dangerouslySetInnerHTML={{
                                              __html: opcion?.[etiqueta.id],
                                            }}
                                          />
                                          </div>
                                          {(etiqueta.id === 'deducibleValor' && opcion?.deducibleTexto !== '') && <ButtonPrime
                                            type="button"
                                            style={{ borderRadius: '25%' }}
                                            className=" p-button-text p-button-plain p-0 pl-1 font-20px button-help-planes mt-3"
                                            tooltip={opcion?.deducibleTexto}
                                          >
                                            <i
                                              className="pi pi-question-circle"
                                              style={{ fontSize: '1rem' }}
                                            />
                                          </ButtonPrime>}
                                          {(etiqueta.id === 'codigoRetroactividad') && <div className="font-source-sans-regular font-19px text-lg-center text-left mt-3">{opcion?.popUp?.find(re => re.seleccion === true)?.retroactividad}</div>}
                                        </div>
                                      </div>
                                    </div>
                                  </CoberturaXL>
                                </div>
                              ))}
                            </div>
                          </div>
                          <div className="d-flex justify-content-center w-100 my-3">
                            <Button
                              variant={
                                value === opcion?.[identificador] ? 'primary' : 'outline-primary'
                              }
                              className="mx-auto text-center w-100"
                              style={{ whiteSpace: 'break-spaces' }}
                              onClick={() => { setOpcionSeleccionada(opcion);; onChange(opcion?.[identificador]); (ModalPlan) && openPopUp(opcion) }}
                            >
                              <span className="text-wrap">ELIJO ESTE PLAN</span>
                            </Button>
                          </div>
                        </div>
                      );
                    })}
                  </div>

                </ButtonGroup>
              </div>

              <div className="text-center mx-auto">
                <ErrorMessage
                  name={name}
                  errors={errors}
                  render={({ message }) => <Error width="95%">{message}</Error>}
                />
              </div>
            </React.Fragment >
          );
        }}
      />


    </React.Fragment >
  );
};



const CoberturaXL = styled.div`
  font-size: 1rem;
  /* font-size: 20px;
  font-family: "SourceSansPro-Regular", Arial, Helvetica, sans-serif; */
  color: #151515;
  @media (min-width: 1290px) {
    height: ${(props) =>
    match(props.length)
      .case((n) => n >= 0 && n <= 30, '20px')
      .case((n) => n >= 31 && n <= 50, '30px')
      .case((n) => n >= 51 && n <= 80, '50px')
      .case((n) => n >= 81 && n <= 85, '60px')
      .case((n) => n >= 91 && n <= 120, '100px')
      .default('100px')};
  }
  align-items: center;

  & .info {
    font-weight: bold;
  }
`;
